import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaGlobe,
  FaCogs,
  FaChartLine,
  FaHandshake,
  FaUsers,
  FaShieldAlt,
  FaAward,
  FaLightbulb,
  FaUserFriends,
  FaMedal,
  FaSignInAlt, // <-- Add this line
} from 'react-icons/fa';

import { sectorsData } from './SectorDetail';
import './HomePage.css';

import ashrafiaLogo from '../logos/Ashraf_enterprises.png';
import hqBuilding from '../logos/ashrafiabuilding.png';
import ashrafTextileLogo from '../logos/asraf_textile.png';
import ashrafiaFoodLogo from '../logos/Ashraf_food_Processing_Industries.png';
import yarnDivisionLogo from '../logos/yarn_division.png';
import kkCarpetsLogo from '../logos/KK_Carpets.png';
import rekoSportsLogo from '../logos/Reko_Sports.png';
import rhSportsArenaLogo from '../logos/RH_Sport_Arena.png';
import glitzLogo from '../logos/GLITZ.png';
import ashrafiaTechnologiesLogo from '../logos/AshrafTechnologies.png';
import ashrafiaEnergyLogo from '../logos/Ashraf_Energy.png';
import ashrafDistributorLogo from '../logos/Ashraf_Disrtibutor.png';
import rhEnterprisesLogo from '../logos/RH_Enterprises.png';
import ashrafiaGoatFarmLogo from '../logos/Ashraf_Farm.png';
import cpw3GinumLogo from '../logos/CPWS_GINUM.png';
import noorUnAleaNoorLogo from '../logos/Nuawa_Ali_Noor.jpeg';
import faiqEnterprisesLogo from '../logos/Faiq_Enterprises.png';
import ashrafHospitalLogo from '../logos/Ashraf_Hospital.png';
import kkIndustriesLogo from '../logos/kkindustrieslogo.png';
import kkMatsLogo from '../logos/kkmatslogo.png';

//const kkIndustriesLogo = kkCarpetsLogo;


const sectorLogos = {
  1: ashrafTextileLogo,
  2: ashrafiaFoodLogo,
  3: yarnDivisionLogo,
  4: kkCarpetsLogo,
  5: rekoSportsLogo,
  6: rhSportsArenaLogo,
  7: glitzLogo,
  8: ashrafiaTechnologiesLogo,
  9: kkIndustriesLogo,
  10: ashrafiaEnergyLogo,
  11: ashrafDistributorLogo,
  12: rhEnterprisesLogo,
  13: ashrafiaGoatFarmLogo,
  14: kkMatsLogo,
  15: cpw3GinumLogo,
  16: noorUnAleaNoorLogo,
  17: faiqEnterprisesLogo,
  18: ashrafHospitalLogo,
};

export default function HomePage() {
  const navigate = useNavigate();

  const handleCardClick = (slug) => {
    navigate(`/sector/${slug}`);
  };

  return (
    <div className="ashrafia-homepage">

      {/* Hero */}
      <section className="ashrafia-homepage-hero">

        <div className="ashrafia-hero-left">
          <div className="ashrafia-brand-area">
            <img
              src={ashrafiaLogo}
              alt="Ashrafia Group of Industries"
              className="ashrafia-main-logo"
            />
          </div>

          <h1 className="ashrafia-main-heading">
            OUR{' '}
            <span className="ashrafia-gold-text">18 SECTORS</span>
          </h1>

          <div className="ashrafia-heading-underline" />

          <div className="ashrafia-hero-tagline">
            ONE GROUP. ENDLESS POSSIBILITIES.
          </div>

          <p className="ashrafia-hero-description">
            From textiles to healthcare, from energy to sports,
            our diverse portfolio reflects our commitment to
            innovation, quality and nation-building.
          </p>
          {/* External Login Button Section */}
      <div className="ashrafia-login-container">
        <a
          href="https://erp.ashrafgroupind.com" // Replace with your target website URL
          target="_blank"
          rel="noopener noreferrer"
          className="ashrafia-login-button"
        >
          <FaSignInAlt className="ashrafia-login-icon" />
          <span>Access Portal / Login</span>
        </a>
      </div>

          <p className="ashrafia-hero-strong">
            18 strong sectors. One unified purpose.
          </p>
        </div>
        

        <div className="ashrafia-homepage-center">
          <div className="ashrafia-center-icon">
            <FaUsers size={22} color="#0b2545" />
          </div>

          <h3 className="ashrafia-center-heading">
            DIVERSE IN BUSINESS.
            <br />
            UNITED IN PURPOSE.
          </h3>

          <div className="ashrafia-center-gold-line" />

          <p className="ashrafia-center-description">
            Each sector represents our strength, vision
            and drive to create value across Pakistan
            and the world.
          </p>
        </div>

        <div className="ashrafia-homepage-right">
          <div className="ashrafia-homepage-building">
            <img
              src={hqBuilding}
              alt="Ashrafia Group Headquarters"
              className="ashrafia-building-image"
            />
          </div>
        </div>

      </section>

      {/* Section title */}
      <section className="ashrafia-homepage-section-heading">
        <div className="ashrafia-gold-line" />
        <h2 className="ashrafia-section-title">OUR 18 SECTORS</h2>
        <div className="ashrafia-gold-line" />
      </section>

      <p className="ashrafia-section-subtitle">
        Tap any sector to explore our businesses
      </p>

      {/* Sector cards */}
      <section className="ashrafia-homepage-grid">
        {sectorsData.map((sector) => (
          <div
            key={sector.id}
            className="ashrafia-sector-card"
            onClick={() => handleCardClick(sector.slug)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleCardClick(sector.slug);
              }
            }}
          >
            <div className="ashrafia-number-badge">
              {String(sector.id).padStart(2, '0')}
            </div>

            <div className="ashrafia-logo-container">
              <img
                src={sectorLogos[Number(sector.id)]}
                alt={sector.name}
                className="ashrafia-sector-logo"
              />
            </div>

            <div className="ashrafia-sector-card-text">
              <h3 className="ashrafia-sector-name">{sector.name}</h3>
              <p className="ashrafia-sector-description">{sector.desc}</p>
            </div>
          </div>
        ))}
      </section>
      

      {/* Values */}
      <section className="ashrafia-homepage-values">
        <ValueItem
          icon={<FaGlobe />}
          title="18 SECTORS"
          subtitle="ONE GROUP"
          description="Diversified. Resilient. Future Ready."
        />
        <ValueItem
          icon={<FaCogs />}
          title="INNOVATION"
          subtitle="DRIVEN"
          description="Empowering industries with modern solutions."
        />
        <ValueItem
          icon={<FaChartLine />}
          title="SUSTAINABLE"
          subtitle="GROWTH"
          description="Building value through responsible growth."
        />
        <ValueItem
          icon={<FaHandshake />}
          title="TRUST & LEGACY"
          subtitle="120+ YEARS"
          description="120+ years of trust, built by generations."
        />
        <ValueItem
          icon={<FaUsers />}
          title="PEOPLE AT"
          subtitle="THE CORE"
          description="Empowered people driving our success."
        />
      </section>

      {/* Footer */}
      <footer className="ashrafia-homepage-footer">
        <div className="ashrafia-footer-left">
          <div className="ashrafia-page-number"></div>
          <div className="ashrafia-footer-divider" />
          <div>
            <div className="ashrafia-company-name">
              ASHRAF GROUP OF INDUSTRIES
            </div>
            <div className="ashrafia-company-tagline">
              Building Legacy. Powering the Future.
            </div>
          </div>
        </div>

        <div className="ashrafia-homepage-footer-right">
          <FooterItem icon={<FaShieldAlt />} text="TRUST" />
          <FooterItem icon={<FaAward />} text="QUALITY" />
          <FooterItem icon={<FaLightbulb />} text="INNOVATION" />
          <FooterItem icon={<FaUserFriends />} text="TEAMWORK" />
          <FooterItem icon={<FaMedal />} text="EXCELLENCE" />
        </div>
      </footer>

    </div>
  );
}

function ValueItem({ icon, title, subtitle, description }) {
  return (
    <div className="ashrafia-value-item">
      <div className="ashrafia-value-icon">
        {React.cloneElement(icon, { size: 28, color: '#f0a51a' })}
      </div>
      <div className="ashrafia-value-content">
        <div className="ashrafia-value-title">{title}</div>
        <div className="ashrafia-value-subtitle">{subtitle}</div>
        <div className="ashrafia-value-description">{description}</div>
      </div>
    </div>
  );
}

function FooterItem({ icon, text }) {
  return (
    <div className="ashrafia-footer-item">
      <span className="ashrafia-footer-icon">
        {React.cloneElement(icon, { size: 13, color: '#f0a51a' })}
      </span>
      <span>{text}</span>
    </div>
  );
}
